(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["densia-home-comparison"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var tab = event.target.closest('[data-densia-comparison-tab]');
    if (!tab) return;

    var root = tab.closest('[data-densia-home-comparison]');
    if (!root) return;

    var idx = tab.getAttribute('data-densia-comparison-index');
    if (idx === null) return;

    var tabs = root.querySelectorAll('[data-densia-comparison-tab]');
    var panels = root.querySelectorAll('[data-densia-comparison-panel]');

    for (var i = 0; i < tabs.length; i++) {
      var t = tabs[i];
      var active = t.getAttribute('data-densia-comparison-index') === idx;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-selected', active ? 'true' : 'false');
      t.setAttribute('tabindex', active ? '0' : '-1');
    }

    for (var j = 0; j < panels.length; j++) {
      var p = panels[j];
      var show = p.getAttribute('data-densia-comparison-panel') === idx;
      p.classList.toggle('is-active', show);
      if (show) {
        p.removeAttribute('hidden');
      } else {
        p.setAttribute('hidden', '');
      }
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

    var tab = event.target.closest('[data-densia-comparison-tab]');
    if (!tab) return;

    var root = tab.closest('[data-densia-home-comparison]');
    if (!root) return;

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-densia-comparison-tab]'));
    var currentIndex = tabs.indexOf(tab);
    if (currentIndex < 0) return;

    var nextIndex =
      event.key === 'ArrowRight'
        ? Math.min(currentIndex + 1, tabs.length - 1)
        : Math.max(currentIndex - 1, 0);

    if (nextIndex !== currentIndex) {
      event.preventDefault();
      tabs[nextIndex].focus();
      tabs[nextIndex].click();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["densia-home-results"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sectionId = '{{ section.id }}';
    const track = document.getElementById('densia-home-results-track-' + sectionId);
    const section = document.getElementById('densia-home-results-' + sectionId);

    if (!track || !section) return;

    const dots = section.querySelectorAll('[data-densia-home-results-dot]');
    const items = track.querySelectorAll('.densia-home-results__track-item');

    if (!dots.length || !items.length) return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const setActiveDot = (index) => {
      dots.forEach((dot, i) => {
        const isActive = i === index;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    };

    const getActiveIndex = () => {
      const trackRect = track.getBoundingClientRect();
      const trackCenter = trackRect.left + trackRect.width / 2;
      let closestIndex = 0;
      let closestDistance = Infinity;

      items.forEach((item, index) => {
        const itemRect = item.getBoundingClientRect();
        const itemCenter = itemRect.left + itemRect.width / 2;
        const distance = Math.abs(itemCenter - trackCenter);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    };

    let scrollRaf = null;

    track.addEventListener(
      'scroll',
      () => {
        if (scrollRaf) cancelAnimationFrame(scrollRaf);
        scrollRaf = requestAnimationFrame(() => {
          setActiveDot(getActiveIndex());
        });
      },
      { passive: true }
    );

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = Number(dot.getAttribute('data-densia-home-results-dot'));
        const item = items[index];

        if (!item) return;

        const scrollLeft = item.offsetLeft - (track.clientWidth - item.clientWidth) / 2;

        track.scrollTo({
          left: scrollLeft,
          behavior: prefersReducedMotion ? 'auto' : 'smooth',
        });

        setActiveDot(index);
      });
    });

    setActiveDot(0);
  })();

  } catch(e) { console.error(e); }
})();
})();
